import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';

    var orderDetailHistory = {
        templateUrl: require('./order-detail-history.html'),
        bindings: {
            order: '<', // Commande
            invoices: '<' // Factures associés à la commande
        },
        controller: OrderDetailHistoryController
    };

    function OrderDetailHistoryController() {
        var vm = this;
        vm.getPdfLink = getPdfLink;

        /**
         * Fournit le lien vers le Pdf de la facture.
         * @param invoiceNumber Numéro de facture à chercher
         */
        function getPdfLink(invoiceNumber) {
            if (vm.invoices) {
                var invoiceFind = _.filter(vm.invoices, { number: invoiceNumber });
                if (invoiceFind.length > 0) {
                    return invoiceFind[0].getPdfLink();
                }
            }
        }
    }

    angular.module('app.kissorder').component('orderDetailHistory', orderDetailHistory);
})();
